import { Injectable, inject } from '@angular/core';
import * as profileActions from './state/profile.actions';
import { Store } from '@ngrx/store';
import { State } from '@wam/shared';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  store = inject<Store<State>>(Store);

  toggleLanguage(language: string): void {
    this.store.dispatch(profileActions.updateLanguage({ language }));
  }

  toggleTabPosition(tabPosition: 'top' | 'left'): void {
    this.store.dispatch(profileActions.toggleTabPosition({ tabPosition }));
  }
}
